<template><ValidationObserver v-slot="{ handleSubmit, invalid }">
    <b-modal :id="modalId" title="Thêm tài khoản" ok-title="Xác nhận" cancel-title="Đóng" size="md">
      <template #modal-header>
        <h4>Thêm tài khoản</h4>
      </template>
      <template #default>
        <div class="container-fluid">
          <div class="row">
            <div class="col-12">
              <b-form @submit.prevent="handleSubmit(onSubmit)">
                <b-form-group label="Chọn công ty">
                  <v-select
                    v-model="network"
                    :reduce="opt => opt.id"
                    :options="networkOptions" placeholder="Chọn"/>
                </b-form-group>
                <b-form-group label="Thuộc tài khoản gốc">
                  <v-select
                    v-model="root_account"
                    :options="accountOptions"
                    placeholder="Chọn"
                  />
                </b-form-group>
                <ValidationProvider name="username" v-slot="{ errors }">
                  <b-form-group label="Tên đăng nhập">
                    <b-row>
                      <b-col>
                        <b-form-input
                          v-model="username"
                          type="text"
                          :class="(errors.length > 0 ? ' is-invalid' : '')"></b-form-input>
                        <div class="invalid-feedback">
                          <span>{{ errors[0] }}</span>
                        </div>
                      </b-col>
                    </b-row>
                  </b-form-group>
                </ValidationProvider>
                <ValidationProvider name="password" v-slot="{errors}">
                  <b-form-group label="Mật khẩu">
                    <b-row>
                      <b-col>
                        <b-form-input
                          v-model="password"
                          type="password"
                          :class="(errors.length > 0 ? ' is-invalid' : '')"
                        ></b-form-input>
                        <div class="invalid-feedback">
                          <span>{{ errors[0] }}</span>
                        </div>
                      </b-col>
                    </b-row>
                  </b-form-group>
                </ValidationProvider>
                <ValidationProvider name="pincode" v-slot="{errors}">
                  <b-form-group label="Mã an toàn">
                    <b-row>
                      <b-col>
                        <b-form-input
                          v-model="pincode"
                          type="text"
                          :class="(errors.length > 0 ? ' is-invalid' : '')"
                        ></b-form-input>
                        <div class="invalid-feedback">
                          <span>{{ errors[0] }}</span>
                        </div>
                      </b-col>
                    </b-row>
                  </b-form-group>
                </ValidationProvider>
                <ValidationProvider name="note" v-slot="{errors}">
                  <b-form-group label="Chú thích">
                    <b-row>
                      <b-col>
                        <b-form-input
                          v-model="note"
                          type="text"
                          :class="(errors.length > 0 ? ' is-invalid' : '')"
                        ></b-form-input>
                        <div class="invalid-feedback">
                          <span>{{ errors[0] }}</span>
                        </div>
                      </b-col>
                    </b-row>
                  </b-form-group>
                </ValidationProvider>
                <b-checkbox
                  v-model="load_childs"
                  class="custom-checkbox-color my-checkbox"
                  name="check-button"
                >
                  <span>Cho phép lấy tài khoản cấp con</span>
                </b-checkbox>
              </b-form>
              <span class="text-danger">{{serverError}}</span>
            </div>
          </div>
        </div>
      </template>
      <template #modal-footer>
        <b-button variant="primary" @click="handleSubmit(onSubmit)" :disabled="serverRequesting">Xác nhận</b-button>
        <b-button variant="default" @click="$bvModal.hide(modalId)">Đóng</b-button>
      </template>
    </b-modal>
  </ValidationObserver>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import { localize } from 'vee-validate'
import api from '../../../store/api'

export default {
  name: 'AccountCreateModal',
  data () {
    return {
      network: '',
      root_account: '',
      username: '',
      password: '',
      pincode: '',
      note: '',
      load_childs: true
    }
  },
  props: {
    modalId: {
      type: String,
      default: 'account-creator-modal'
    },
    inputStyle: {
      type: Object,
      default: () => {
        return {
          width: '100%',
          display: 'block'
        }
      }
    },
    networkId: {
      type: String,
      default: null
    }
  },
  created () {
    localize('en', {
      fields: {
        // 'username': { required: 'Tên đăng nhập không được để trống' },
        // 'password': { required: 'Mật khẩu không được để trống' },
        // 'pincode': { required: 'Mã an toàn không được để trống' }
      }
    })
  },
  mounted () {
  },
  computed: {
    ...mapGetters({
      'networkOptions': 'Network/listOptionsState',
      'accountOptions': 'Account/listOptionsState',
      'serverError': 'Setting/serverErrorsState',
      'serverRequesting': 'Setting/serverRequestingState'
    })
  },
  watch: {
    networkId: function (newVal, oldVal) {
      if (newVal) {
        if (this.networkId) {
          this.network = this.networkId
        }
      }
    }
  },
  methods: {
    ...mapActions({
      loadList: 'Account/loadList'
    }),
    onSubmit ($event) {
      // call api
      api.account.create({
        'network_id': this.network,
        'parent_id': this.root_account.value,
        'username': this.username,
        'password': this.password, // (optional)
        'pincode': this.pincode, // (optional)
        'description': this.note, // (optional)
        'load_childs': this.load_childs === true ? '1' : '0'
      }).then((res) => {
        this.$swal({
          icon: 'success',
          title: 'Thêm thành công'
        })

        // reload all accounts after click "Add", this will create quick UX load on AutoReport page
        this.loadList()

        this.$emit('created-account')

        this.username = ''
        this.password = ''
        this.pincode = ''
        this.note = ''

        this.$bvModal.hide(this.modalId)
      }).catch(() => {
        this.$swal({
          icon: 'error',
          title: 'Lỗi...',
          text: this.serverError
        })
      })
    }
  }
}
</script>
